export default "__VITE_ASSET__gsUp93nU__"